import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=dd6ad536&scoped=true&"
import script from "./dashboard-layout.vue?vue&type=script&lang=js&"
export * from "./dashboard-layout.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-layout.vue?vue&type=style&index=0&id=dd6ad536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6ad536",
  null
  
)

export default component.exports